import { Component, OnInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';
import * as bank from '../../bank.json';
import { Router } from "@angular/router";
import { UsersService } from '../services/users.service';
import { AnyCnameRecord } from 'dns';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit {
  userDetails: any;
  detailList: any=[];
  amount: any;
  amountType: any={};
  dataMethod:any;
  showPopUp: boolean;
  hideShowBankStatus:any
  submitted:any=false
  walletBalance: any;
  
  accountType:any='';
  searchBank:any
  updatedBalance: number;
  showPopUpError: boolean;
  methodForm:any=false
  bankList: any;
  method_list:any;
  type:any;
  loading: boolean = false;
  index: any = 0;
  payMethodList:any;
  restrictedIdx:any=[];
  paymentForms:any={}
  Form: FormGroup;
  upiForm:FormGroup;
  paymentDta:any
  saveIndex:any=0;
  constructor(private fb: FormBuilder,private router: Router, private sportService: SportService, private toastr: ToastrService, private cdRef: ChangeDetectorRef, private usersService: UsersService, private sport: SportService)
   {
    this.bankList = bank['default']?.message;
   }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.getUserBalance();
    this.list();
    this.list_method()
    this.depositMethod()
    this.withdrawFrom()
    this.upiDetailFrom()
  }

  get f() { return this.Form.controls; }
  get u() { return this.upiForm.controls; }
  withdrawFrom() {
    this.Form = this.fb.group({
      user_id: ['', Validators.required],
      method_id: ['', Validators.required],
      bank_holder_name: ['', Validators.required],
      bank_name: ['', Validators.required],
      ifsc_code: ['', [Validators.required,this.validateIFSCCode]],
      account_no: ['', [Validators.required,this.validateAccountNumber]]
    });
    this.Form.controls['user_id'].setValue(this.userDetails._id);
  }
  validateAccountNumber(control) {
    // Implement your custom validation logic for account numbers
    // Example: Check for a specific format
    const accountNumberRegex = /^[0-9]{9,18}$/;
    return accountNumberRegex.test(control.value) ? null : { invalidAccountNumber: true };
  }
   // Custom validator for IFSC Code
   validateIFSCCode(control) {
    // Implement your custom validation logic for IFSC codes
    // Example: Check for a specific format
    const ifscCodeRegex = /^[A-Z]{4}\d{7}$/;
    return ifscCodeRegex.test(control.value) ? null : { invalidIFSCCode: true };
  }
  
  showBankFormStatus: boolean = false;
  showBankForm() {
    this.hideShowBankStatus = false;
    this.showBankFormStatus = !this.showBankFormStatus;
  }
  selectBank(bank) {
    this.Form.controls['bank_name'].setValue(bank);
  }

  upiDetailFrom() {
    this.upiForm = this.fb.group({
      user_id: ['', Validators.required],
      method_id: ['', Validators.required],
      bank_holder_name: ['', Validators.required],
      others: ['', Validators.required]
    });
    this.upiForm.controls['user_id'].setValue(this.userDetails._id);
  }

  depositMethod() {
    let data={
      user_id:this.userDetails._id,
      parent_id:this.userDetails.parent_id,
    }
    
    this.sport.paymentwithdrawMethodList(data).subscribe((res) => {
       console.log(res)
      if (res.status == true) {
        this.payMethodList = res.data;
        this.paymentDta=res.data;
        this.restrictedIdx=res.data.map((val)=>val.type)
        this.showDetail(this.payMethodList[this.saveIndex]);
      } else {
        this.toastr.error('Withdraw Method is coming Soon.')
      }
    })
  }

  

  selectPayment(event){
    let value=event.target.value
    this.paymentForms=this.payMethodList.find((val)=>val._id==value)
    this.accountType=this.paymentForms.type
    this.Form.controls['method_id'].setValue(this.paymentForms._id);
    this.upiForm.controls['method_id'].setValue(this.paymentForms._id);

  }

  withdrawdetails() {
    this.router.navigate(['withdraw-details'])
  }
  list() {
    this.loading = true;
    let data = {
      user_id: this.userDetails._id,
     
    }
    
    this.sport.paymentActiveMethod(data).subscribe((res) => {
      console.log(res)
      if (res.status == true) {
        this.detailList = res.data;
      } else {
        this.toastr.error(res.msg)
      }
      this.loading = false;
      
    })
  }


  list_method() {
    
    let data = {
      user_id: this.userDetails._id,
      parent_id: this.userDetails.parent_id,
    }
    
    this.sport.getactiveMethodList(data).subscribe((res) => {
        console.log(res)
      if (res.status == true) {
        this.method_list = res.data;
      } else {
        this.toastr.error(res.msg)
      }
    
      
      
    })
  }

  hideShowBankdetail() {
    this.showBankFormStatus = false;
    this.hideShowBankStatus = !this.hideShowBankStatus;
  }
  

  addPaymentMethod() {
    this.submitted = true;
    let payment_details:any=[];
    if(this.accountType==='Bank')
    {
      console.log(this.Form)
      if (this.Form.invalid) {
        return;
      }
      let obj={
        bank_holder_name:this.Form.controls['bank_holder_name'].value,
        bank_name:this.searchBank,
        ifsc_code:this.Form.controls['ifsc_code'].value,
        account_no:this.Form.controls['account_no'].value,
      }
      payment_details.push(obj);
      let parms={
        user_id:this.userDetails?._id,
        user_name:this.userDetails?.user_name,
        type:this.accountType,
        name:this.accountType,
        payment_details:payment_details,
  
      }
   
      this.sport.addwithdrawMethodList(parms).subscribe((res) => {
        if (res.status == true) {
          this.toastr.success(res.msg);
          this.hideShowBankdetail();
          this.accountType='';
          this.methodForm=false
          this.showDetail(this.payMethodList[this.saveIndex]);
        } else {
          this.toastr.error(res.msg)
        }
      })
    }
    else{
      console.log(this.upiForm)
      if (this.upiForm.invalid) {
        return;
      }
    
      let obj={
        bank_holder_name:this.upiForm.controls['bank_holder_name'].value,
        account_no:this.upiForm.controls['others'].value,
      }
      payment_details.push(obj);
      let parms={
        user_id:this.userDetails?._id,
        user_name:this.userDetails?.user_name,
        type:this.accountType,
        name:this.accountType,
        payment_details:payment_details,
  
      }
      this.sport.addwithdrawMethodList(parms).subscribe((res) => {
        if (res.status == true) {
          this.toastr.success(res.msg);
          this.hideShowBankdetail();
          this.accountType='';
          this.methodForm=false
          this.upiForm.controls['bank_holder_name'].setValue('');
          this.upiForm.controls['others'].setValue('');
          this.showDetail(this.payMethodList[this.saveIndex]);
        } else {
          this.toastr.error(res.msg)
        }
      })
    }
    
  }

  delete(list) {
    if (confirm('Delete this account detail')) {
      let param={
        _id:list?._id,
        visible:false,
        type:list?.type,
        u_type:true
      }
     
      this.sport.updateWithdrawMethod(param).subscribe((res) => {
        if (res.status == true) {
          this.toastr.success('withdraw details remove successfully..');
          this.showDetail(1)
        } else {
          this.toastr.error(res.msg)
        }
      })
    }
  }

  getInput(method,event){
    this.amountType[method._id]=event.target.value
  }

 
  withdrawData(id) {
    this.loading = true;
   // this.index = 1;

    this.cdRef.detectChanges()
   
   
    let validateInput=this.payMethodList.find((val)=>val.type==id?.type);
    console.log(this.payMethodList)
    console.log(id?.type)
  
   
   
    if (id._id in this.amountType) {

      if(validateInput){

        if(validateInput.max_amount<parseInt(this.amountType[id._id])){
          this.toastr.error('Max Amount Limit: '+validateInput.max_amount)
          return
        }
        else if(validateInput.min_amount>parseInt(this.amountType[id._id])){
          this.toastr.error('Min Amount Limit: '+validateInput.min_amount)
          return
        }
        else{
          
        }
        let data = {
          user_id: this.userDetails._id,
          user_name: this.userDetails.user_name,
          amount: parseInt(this.amountType[id._id]),
          method_id:id?._id,
      
        }


       
        this.sport.createWithdraw(data).subscribe((res) => {
          if (res.status == true) {
            this.amount = 0;
            this.toastr.success(res.msg);
            this.amountType={}
            this.list()
          } else {
            this.toastr.error(res.msg)
          }
          this.index = 0;
          this.cdRef.detectChanges()
          this.loading = false;
        })

  
      }
     
       
      
      
    } else {
      this.toastr.error('Please Enter Amount ...')
    }
  }
  getPaymentIdx(val){
 
    this.type=val;
    this.showDetail(val)
  }

  showDetail(param) {
    
    this.cdRef.detectChanges();
    let data = {
      user_id: this.userDetails._id,
      parent_id: this.userDetails.parent_id,
    }
    this.sport.paymentWithdrawDetailp(data).subscribe((res) => {
      
    
      this.dataMethod =res.data.filter(item => this.restrictedIdx.includes(item.type))
    
    })
  }

  validate() {
   
    if (this.updatedBalance >= (this.amount)) {
      this.showPopUpError = false;
      if (this.amount > 0) {
        this.showPopUp = true;
      } else {
        this.showPopUp = false;
      }
      this.cdRef.detectChanges();
    } else {
      this.showPopUpError = true;
      this.showPopUp = false;
      this.cdRef.detectChanges();
    }
  }
  getUserBalance() {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    let data = {};
    this.sportService.getUserBalance(data).subscribe(response => {
      if (response.status == true) {
        this.walletBalance = response.data;
        this.updatedBalance = (this.walletBalance.balance) - 100;
        this.cdRef.detectChanges();
      } else {
        this.toastr.error(response.msg, '', {
          timeOut: 10000,
        });
        this.cdRef.detectChanges();
      }
    })
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      alert('Text copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

}
